import Button from '@mui/material/Button'
import { withStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

const ContinueButtonCustomStyle = withStyles(Button, (theme: Theme) => ({
  root: {
    color: '#FFF !important',
    border: '4px solid #F13C00',
    lineHeight: '20px',
    backgroundColor: '#F13C00 !important',
    borderRadius: '27px',
    boxSizing: 'border-box',
    padding: '6px 25px',
    textAlign: 'center',
    fontSize: '18px',
    letterSpacing: '0.12em',
    minHeight: '43px',
    height: 'auto',
    fontWeight: 'bold',
    '&$disabled': {
      opacity: '0.5',
    },
    '&:hover': {
      color: '#FFF !important',
      backgroundColor: '#652106 !important',
      border: '4px solid #652106',
    },
    [theme.breakpoints.between(600, 1280)]: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.07em',
      minHeight: '50px',
      width: '100%',
    },
    [theme.breakpoints.between(0, 600)]: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.07em',
      minHeight: '50px',
      width: '100%',
    },
  },
  disabled: {},
}))

export default ContinueButtonCustomStyle
